// extracted by mini-css-extract-plugin
export default {"myCartPageWrapper":"myCart_myCartPageWrapper__7zqdK","myCartWrapper":"myCart_myCartWrapper__N4WF5"};